import dashboardIcon from "../assets/images/dashboard-icon.svg";
import dashboardIconActive from "../assets/images/dashboard-icon-active.svg";
import contantListIconActive from "../assets/images/contact-list-icon-active.svg";
import contantListIcon from "../assets/images/contact-list-icon.svg";
import messageIcon from "../assets/images/messages-icon.svg";
import messageIconActive from "../assets/images/messages-icon-active.svg";
import voiceMailIcon from "../assets/images/voice-mails-icon.svg";
import voiceMailIconActive from "../assets/images/voice-mails-icon-active.svg";
import customMessageIcon from "../assets/images/custom-message-icon.svg";
import customMessageIconActive from "../assets/images/custom-message-icon-active.svg";
import settingsIconActive from "../assets/images/settings-icon-active.svg";
import settingsIcon from "../assets/images/settings-icon.svg";
import contactsChip from "../assets/images/contacts-chip.svg";
import messagesChip from "../assets/images/messages-chip.svg";
import voiceChip from "../assets/images/voice-chip.svg";
import customMessageChip from "../assets/images/custom-message-chip.svg";
import settingChip from "../assets/images/setting-chip.svg";

export const menus = [
  {
    title: "Dashboard",
    to: "/",
    icon: dashboardIcon,
    activeIcon: dashboardIconActive,
    active: ["/"],
    subCategories: false,
  },
  {
    title: "Contacts List",
    to: "/contacts",
    icon: contantListIcon,
    activeIcon: contantListIconActive,
    active: ["/contacts"],
    subCategories: false,
    chipIcon: contactsChip,
    classname: "contacts",
  },
  {
    title: "Messages",
    to: "/messages",
    icon: messageIcon,
    activeIcon: messageIconActive,
    active: ["/messages"],
    subCategories: false,
    chipIcon: messagesChip,
    classname: "all-messages",
  },
  {
    title: "Voicemail",
    to: "/voicemail",
    icon: voiceMailIcon,
    activeIcon: voiceMailIconActive,
    active: ["/voicemail"],
    subCategories: false,
    chipIcon: voiceChip,
    classname: "voice",
  },

  {
    title: "Custom Messages",
    to: "/missed-calls",
    icon: customMessageIcon,
    activeIcon: customMessageIconActive,
    active: ["/missed-calls", "/wait-time", "/templates", "/reminders"],
    chipIcon: customMessageChip,
    classname: "custom-messages",
    subCategories: [
      {
        title: "Missed Calls",
        to: "/missed-calls",
        active: ["/missed-calls"],
      },
      {
        title: "Wait Time",
        to: "/wait-time",
        active: ["/wait-time"],
      },
      {
        title: "Templates",
        to: "/templates",
        active: ["/templates"],
      },
      {
        title: "Reminders",
        to: "/reminders",
        active: ["/reminders"],
      },
    ],
  },
  {
    title: "Settings",
    to: "/profile",
    icon: settingsIcon,
    activeIcon: settingsIconActive,
    chipIcon: settingChip,
    classname: "settings",
    active: [
      "/profile",
      "/payments",
      "/preferences",
      "/blocked-numbers",
      "/employees",
      "/voicemail-destination",
      "/audit-logs",
      "/import-contacts",
      "/change-password",
      "/change-fontsize",
      "/ai-assistant",
    ],
    subCategories: [
      {
        title: "Profile",
        to: "/profile",
        active: ["/profile"],
      },
      {
        title: "Payments",
        to: "/payments",
        active: ["/payments"],
      },
      {
        title: "Preferences",
        to: "/preferences",
        active: ["/preferences"],
      },
      {
        title: "Blocked Numbers",
        to: "/blocked-numbers",
        active: ["/blocked-numbers"],
      },
      {
        title: "Employees",
        to: "/employees",
        active: ["/employees"],
      },
      {
        title: "Voicemail Destination",
        to: "/voicemail-destination",
        active: ["/voicemail-destination"],
      },
      {
        title: "Audit Logs",
        to: "/audit-logs",
        active: ["/audit-logs"],
      },
      {
        title: "Import Contact List",
        to: "/import-contacts",
        active: ["/import-contacts"],
      },
      {
        title: "Change Password",
        to: "/change-password",
        active: ["/change-password"],
      },
      {
        title: "AI Assistant",
        to: "/ai-assistant",
        active: ["/ai-assistant"],
      },
    ],
  },
];
